module.exports = __webpack_public_path__ + "img/fontWeight.a30d296b.svg";